import { FormValidationRule } from "../types";

const isValidUUID: FormValidationRule = (c, v) => {
    /**
     * We currently have a bespoke implementation of UUID generator in BOI/Library so the following regex fails
     * //const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
     *
     * Until we update the BOI/Library we need to use a less strict regex
     */
    const uuidPattern = /^([a-fA-F0-9]{8}(?:-[a-fA-F0-9]{4}){3}-[a-fA-F0-9]{12}){1}$/g;
    const valid = !(c.type === "boi_uuid" && v && !uuidPattern.test(v));
    return [valid, c.errorMessage || "Invalid UUID provided."];
};

export default isValidUUID;
